import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { cleanProject } from '../../../redux/editor/editor.actions';
import { BusEventType, eventBus } from '../../../utils/EventBus';

// Монотонная эпоха смонтированной страницы редактора. Нужна, потому что отложенную
// очистку проекта нельзя привязать ни к projectId (уход и повторный вход в ТОТ ЖЕ проект
// дают одинаковый id, и старая микрозадача убила бы свежую сессию), ни к простому флагу
// отмены (он живёт в экземпляре хука, а новый вход — новый экземпляр).
let mountEpoch = 0;

/**
 * Жизненный цикл ухода со страницы редактора (WSL-5 + WSL-14).
 *
 * Раньше «сохранить и очистить» знала кнопка «К проектам», поэтому браузерный «назад» и
 * прямой ввод URL уходили мимо: проект оставался в сторе, а sync-сессия продолжала жить
 * на списке проектов. Теперь это знает сама страница, и путь ухода один для всех.
 *
 * Порядок внутри cleanup обязателен:
 *   1. барьер — СИНХРОННО, иначе сохранение уйдёт в сагу уже после PROJECT_CLEAN и будет
 *      отброшено (`if (!project) return`);
 *   2. очистка проекта — отложенно, микрозадачей. В StrictMode React прогоняет
 *      mount → cleanup → mount в одном коммите, и синхронная очистка обнулила бы
 *      только что открытый проект.
 */
export function useLeaveEditorPage() {
  const dispatch = useDispatch();
  const epochRef = useRef(0);

  useEffect(() => {
    mountEpoch += 1;
    epochRef.current = mountEpoch;

    return () => {
      const leavingEpoch = epochRef.current;

      eventBus.emit(BusEventType.EDITOR_FLUSH_PENDING_SAVES, undefined);

      queueMicrotask(() => {
        // Успело смонтироваться что-то новее — уход был не настоящим (StrictMode-реплей)
        // или пользователь уже вернулся в редактор. Чистить нечего и опасно.
        if (mountEpoch !== leavingEpoch) {
          return;
        }

        dispatch(cleanProject());
      });
    };
  }, [dispatch]);
}
